/* eslint-disable react/jsx-one-expression-per-line */

import { Pagination } from 'antd';

interface ScPaginationProps {
    currentPage?: number;
    pageSize?: number;
    total?: number;
    onChange?: (page: number) => void;
    currentCount?: number;
    showSizeChanger?: boolean;
}

const ScPagination = ({
    currentPage,
    pageSize,
    total,
    onChange,
    currentCount,
    showSizeChanger,
}: ScPaginationProps) => (
    <div>
        {total <= pageSize ? (
            <div />
        ) : (
            <div className="text-center">
                <div className="text-center" style={{ marginBottom: '10px' }}>
                    <p style={{ marginBottom: '0px' }} className="text-muted">
                        {'Hiển thị bản ghi '}
                        <span className="text-black">
                            {(currentPage - 1) * pageSize + 1}
                            {' - '}
                            {(currentPage - 1) * pageSize +
                                (currentCount > pageSize
                                    ? pageSize
                                    : currentCount)}
                        </span>
                        {' của '}
                        <span className="text-black">{total}</span>
                    </p>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Pagination
                        current={currentPage}
                        defaultPageSize={pageSize}
                        total={total}
                        onChange={(page) => onChange(page)}
                        showSizeChanger={showSizeChanger}
                    />
                </div>
            </div>
        )}
    </div>
);

export default ScPagination;
